const pagesIndividualMyProfileEn = {
  certificationDetail: {
    breadcrumbs: {
      certificationInfo: 'Certification Info',
    },
    error: 'An error occurred: {{message}}',
    noData: 'No data available',
    tabs: {
      detail: 'Detail',
    },
  },
  devices: {
    pageTitle: 'Devices',
  },
  educationAndQualification: {
    certificationKind: {
      base: 'Basic Certification',
      handling: 'Handling Certification',
      specialty: 'Specialty Certification',
    },
    filterPlaceholder: 'Search by certification name or number...',
    pageTitle: 'Education & Qualification',
    tabs: {
      archived: 'Archived',
      certification: 'Certification',
    },
  },
  header: {
    boss: 'Boss',
    department: 'Dept',
    title: 'My Profile',
    viewLess: 'View less',
    viewMore: 'View more',
  },
  softwares: {
    pageTitle: 'Software',
  },
};

export default pagesIndividualMyProfileEn;
